{
  "title": "Otto's Irresistible Dance",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level enchantment",
  "level": 6,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Choose one creature that you can see within range. The target begins a comic dance in place: shuffling, tapping its feet, and capering for the duration. Creatures that can’t be charmed are immune to this spell.",
    "A dancing creature must use all its movement to dance without leaving its space and has disadvantage on Dexterity saving throws and attack rolls. While the target is affected by this spell, other creatures have advantage on attack rolls against it. As an action, a dancing creature makes a Wisdom saving throw to regain control of itself. On a successful save, the spell ends."
  ],
  "spellLists": ["bard", "wizard"]
}
